module.exports = __webpack_public_path__ + "img/9.af896d6f.webp";